import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import * as homeActions from '../home/redux/apiCall';

import {
  KuposModal,
  KuposModalWithButtons,
  KuposSuccessFailure,
  SvgCircularIcons,
  SvgHome,
} from '../common';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';

import ApiUrls from '../../services/apiUrls';
import CancellationPolicyBlock from './CancellationPolicyBlock';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import FailedCancellation from './FailedCancellation';
import PassengerDetailsBlock from './PassengerDetailsBlock';
import PropTypes from 'prop-types';
import RefundDetailsBlock from './RefundDetailsBlock';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ChangeTicketPolicyBlock from './ChangeTicketPolicyBlock';
import i18next from 'i18next';

export class DefaultPage extends Component {
  static propTypes = {
    cancellation: PropTypes.object.isRequired,
    common: PropTypes.object,
    home: PropTypes.object,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedSeats: {},
      selectedPayment: null,
      showConfirmModal: false,
      showButton2: false,
      buttonText2: null,
      buttonText1: null,
      pbCashSelected: false,
      bankSelected: false,
      creditCardSelected: false,
      paypalSelected: false,
      couponSelected: false,
      cancelSuccess: false,
      renderCancelSuccess: false,
      allSelected: false,
      loading: false,
      is_change_ticket: false,
      reloaded: false,
    };

    this.setState({
      is_change_ticket: sessionStorage.getItem('is_change_ticket') === 'true' ? true : false,
    });
    this.refundBlock = React.createRef();
    this.ticketInfo = sessionStorage.getItem('ticketInfo');
    this.offlineCancel = sessionStorage.getItem('offlineCancel') == 'true' ? true : false;
    if (this.props.home && this.props.home.metaData) {
      this.metaData = this.props.home.metaData;
      if (this.props.common.ticketDetails) {
        this.ticketDetails = this.props.common.ticketDetails;
      }
    } else if (this.ticketInfo) {
      this.ticketInfo = JSON.parse(this.ticketInfo);
      this.ticketDetails = this.ticketInfo.ticketDetails;
      this.metaData = this.ticketInfo.metaData;
      // this.loadTicketDetails();
    }
    this.html = document.querySelector('html');
    this.html.style.scrollBehavior = 'initial';
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }

  loadTicketDetails = () => {
    this.props.actions
      .loadTicketDetails({ url: ApiUrls.ticketDetails(this.ticketDetails.pnr_number) })
      .then(res => {
        // this.props.actions.setTicketDetails(res);
        if (res.body && res.body.pnr_number) {
          this.ticketDetails = res.body;
          this.setState({});
        } else {
        }
      });
  };

  cancelTicketOffline = paramData => {
    console.log('***paramdata is', paramData);
    let dataEnc = CommonService.createJwtFullAndEncrypt(paramData, '@pullman&ts' + '&cancel@');
    this.props.actions
      .apiCall({
        url: ApiUrls.cancelDirect(),
        method: 'POST',
        data: {
          token: dataEnc,
        },
        type: "home"
      })
      .then(res => {
        if (
          res &&
          res.data &&
          res.data.data &&
          res.data.data.data &&
          res.data.status == 200 &&
          res.data.data.code == 200
        ) {
          this.setState({
            showModal: false,
            modalTitle: '',
            modalBody: '',
            onButtonClick1: null,
            showButton2: false,
            buttonText2: null,
            modalIcon: null,
            modalChild: null,
            showCloseIcon: false,
            cancelSuccess: true,
            renderCancelSuccess: true,
            showOtpModal: false,
          });
          this.closeModal();
        } else {
          this.setState({
            showModal: false,
            modalTitle: '',
            modalBody: '',
            onButtonClick1: null,
            showButton2: false,
            buttonText2: null,
            modalIcon: null,
            modalChild: null,
            showCloseIcon: false,
            cancelSuccess: false,
            renderCancelSuccess: true,
            showOtpModal: false,
          });
        }
      });
  };

  componentDidMount() {
    let isChangeTicket = sessionStorage.getItem('is_change_ticket');
    this.isChangeTicketFinal = isChangeTicket === 'true' ? true : false;
    this.setState({
      is_change_ticket: isChangeTicket === 'true' ? true : false,
    });

    this.html.style.scrollBehavior = 'initial';
    setTimeout(() => {
      this.html.style.scrollBehavior = 'smooth';
    }, 300);
    if (!this.props.common.ticketDetails && !this.ticketInfo) {
      this.props.history.push('/');
    } else {
      if (this.props.home && this.props.home.metaData) {
        this.metaData = this.props.home.metaData;
        if (this.props.common.ticketDetails) {
          this.ticketDetails = this.props.common.ticketDetails;
        }
      } else if (this.ticketInfo) {
        this.ticketDetails = this.ticketInfo || this.ticketInfo.ticketDetails;
        this.metaData = this.ticketInfo.metaData;
      }
      for (let k in this.ticketDetails.seat_Details.seat_details) {
        this.state.selectedSeats[k] = false;
      }
      if (
        this.ticketDetails.seat_Details.seat_details &&
        Object.keys(this.ticketDetails.seat_Details.seat_details).length == 1
      ) {
        for (let k in this.ticketDetails.seat_Details.seat_details) {
          this.state.selectedSeats[k] = true;
        }
      }
    }
  }

  componentDidUpdate() {
    if (this.props.common.ticketDetails) {
      let ticketInfo = {
        metaData: this.props.home.metaData,
        ticketDetails: this.props.common.ticketDetails,
      };
      this.ticketDetails = this.props.common.ticketDetails;
      sessionStorage.setItem('ticketInfo', JSON.stringify(ticketInfo));
    }
  }

  onSubmit = () => {
    // let cancel_offline = sessionStorage.getItem('offlineCancel') == 'true ' ? true : false;
    if (this.state.cancel_offline) {
      if (
        !this.state.otp1 ||
        !this.state.otp2 ||
        !this.state.otp3 ||
        !this.state.otp4 ||
        !this.state.otp5 ||
        !this.state.otp6
      ) {
        this.setState({ otpValidationError: true });
        return;
      } else {
        this.setState({ validateOtpPending: true });
      }
    }
    if (this.state.showErrorsModal) {
      this.setState({ showErrorsModal: false });
    }

    // this.setState({ loading: true });
    let errorCount = 0;
    let selectedSeat = 0;
    let inps = document.querySelector('.bank-deposit-subsection-card');
    this.scrollTo = inps;
    let errors = [];
    let totalAmount = 0;
    for (let k in this.ticketDetails.seat_Details.seat_details) {
      if (this.state.selectedSeats[k]) {
        totalAmount += this.ticketDetails.seat_Details.seat_details[k].fare;
        selectedSeat++;
      }
    }
    if (selectedSeat <= 0) {
      // this.refs.toast.show('Por favor, seleccione un asiento.');
      this.scrollTo = document.querySelector('.cancellation-main');
      // seats.scrollIntoView();
      errors.push(this.props.t('CANCEL_TICKET.SELECT_SEAT'));
      this.setState({ showErrorsModal: true, errors: errors });
      return;
    }

    if (!this.state.tncChecked) {
      // this.refs.toast.show('Por favor, seleccione un asiento.');
      this.scrollTo = document.querySelector('.cancellation-main');
      // seats.scrollIntoView();
      errors.push(this.props.t('CANCEL_TICKET.SELECT_TNC'));
      this.setState({ showErrorsModal: true, errors: errors });
      return;
    }
    if (
      !this.state.pbCashSelected &&
      !this.state.bankSelected &&
      !this.state.paypalSelected &&
      !this.state.couponSelected &&
      !this.state.creditCardSelected
    ) {
      // inps.scrollIntoView();
      errors.push(this.props.t('CANCEL_TICKET.SELECT_REFUND'));
      errorCount++;
    }
    if (errorCount > 0) {
      // this.refs.toast.show('POR FAVOR ELIJA UN MÉTODO DE REEMBOLSO');
      this.setState({ showErrorsModal: true, errors: errors, scrollTo: inps.scrollIntoView });
      return;
    }

    if (this.state.creditCardSelected) {
      if (!this.refundBlock.current.isValidCreditCard()) {
        inps.scrollIntoView();
        return;
      }
    } else if (this.state.bankSelected) {
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:2,path:this.makePath(2)})
      if (!this.refundBlock.current.isValid()) {
        inps.scrollIntoView();
        return;
      }
    } else if (this.state.pbCashSelected || this.state.couponSelected) {
      // this.cancelPBCashConfirm()
    } else if (this.state.paypalSelected) {
      if (!this.refundBlock.current.isValidPaypal()) {
        inps.scrollIntoView();
        return;
      }
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:3,path:this.makePath(3)})
    }
    setTimeout(() => {
      this.setState({
        showModal: true,
        modalTitle: this.props.t('CANCEL_TICKET.CANCEL_TICKET_WARNING'),
        buttonText1: this.props.t('CANCEL_TICKET.YES_CONFIRM'),
        showButton2: true,
        buttonText2: this.props.t('PROFILE.YES_GO_BACK'),
        // onButtonClick1: this.callTsCancellationApi,
        onButtonClick1: this.state.cancel_offline ? this.callTsCancellationApi : this.onConfirm,
        totalAmount: totalAmount,
      });
    }, 300);

    // this.onConfirm();
  };

  onErrorModalHide = () => {
    this.setState({ showErrorsModal: false, errors: null });
    setTimeout(() => {
      this.scrollTo.scrollIntoView();
    }, 250);
  };

  onConfirm = () => {
    if (this.state.bankSelected) {
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:2,path:this.makePath(2)})
      this.refundBlock.current.cancelWithCashRefund(2, this.makePath(2));
    } else if (this.state.pbCashSelected || this.state.couponSelected) {
      this.cancelPBCashConfirm();
    } else if (this.state.paypalSelected) {
      this.refundBlock.current.cancelWithCashRefund(3, this.makePath(3));
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:3,path:this.makePath(3)})
    } else if (this.state.creditCardSelected) {
      this.refundBlock.current.cancelWithCashRefund(7, this.makePath(7));
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:3,path:this.makePath(3)})
    }
  };

  showOtpInputs = () => {
    let canCancelData = JSON.parse(sessionStorage.getItem('canCancelData'));
    let errors = [];
    let errorCount = 0;
    let inps = document.querySelector('.bank-deposit-subsection-card');
    this.scrollTo = inps;
    if (!this.state.tncChecked) {
      errors.push(this.props.t('CANCEL_TICKET.SELECT_TNC'));
      this.setState({ showErrorsModal: true, errors: errors });
      return;
    }
    if (
      !this.state.pbCashSelected &&
      !this.state.bankSelected &&
      !this.state.paypalSelected &&
      !this.state.couponSelected &&
      !this.state.creditCardSelected
    ) {
      // inps.scrollIntoView();
      errors.push(this.props.t('CANCEL_TICKET.SELECT_REFUND'));
      errorCount++;
    }
    if (errorCount > 0) {
      // this.refs.toast.show('POR FAVOR ELIJA UN MÉTODO DE REEMBOLSO');
      this.setState({ showErrorsModal: true, errors: errors, scrollTo: inps.scrollIntoView });
      return;
    }
    // return;
    this.setState({
      showOtpModal: true,
      cancel_offline: true,
      api_travel_id: canCancelData.api_travel_id,
    });
  };

  callTsCancellationApi = () => {
    let access_code =
      this.state.otp1 +
      this.state.otp2 +
      this.state.otp3 +
      this.state.otp4 +
      this.state.otp5 +
      this.state.otp6;

    let paramDataCancelTicket = {
      pnr_number: this.ticketDetails && this.ticketDetails.pnr_number,
      travel_date: this.ticketDetails && this.ticketDetails.travel_date,
      api_travel_id: this.state.api_travel_id || null,
      seat_numbers: this.getSelectedSeats(),
      phone_number: this.ticketDetails && this.ticketDetails.phone_number,
      access_code: access_code,
      refund_type: 'Cash',
    };

    let paramDataChangeTicket = {
      pnr_number: this.ticketDetails && this.ticketDetails.pnr_number,
      travel_date: this.ticketDetails && this.ticketDetails.travel_date,
      api_travel_id: this.state.api_travel_id || null,
      seat_numbers: this.getSelectedSeats(),
      phone_number: this.ticketDetails && this.ticketDetails.phone_number,
      access_code: access_code,
      refund_type: 'Cash',
      is_change_ticket: true,
    };
    let paramData = this.isChangeTicketFinal ? paramDataChangeTicket : paramDataCancelTicket;

    this.cancelTicketOffline(paramData);
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      modalTitle: '',
      modalBody: '',
      onButtonClick1: null,
      showButton2: false,
      buttonText2: null,
      modalIcon: null,
      modalChild: null,
      showCloseIcon: false,
    });
  };

  cancelPBCashConfirm = () => {
    let type;
    if (this.state.pbCashSelected) {
      type = 6;
    } else {
      type = 1;
    }
    let path = this.makePath(type);
    console.log('path', path);
    // return;
    this.props.actions.cancelTicket({ url: ApiUrls.cancelTicket(path) }).then(res => {
      this.onResponse(res);
    });
  };

  onResponse = result => {
    this.setState({ loading: false });
    console.log(result);

    this.loadTicketDetails();

    window.scrollTo(0, 0);
    if (result.data && result.data.error) {
      // this.refs.toast.show(result.data.error);
      this.setState({
        cancelSuccess: false,
        renderCancelSuccess: true,
      });
      this.closeModal();
    } else if (result.data && !result.data.success && result.data.body) {
      this.setState({
        cancelSuccess: false,
        renderCancelSuccess: true,
        cancelInfo: result.data.body.message,
      });
      this.closeModal();
    } else if (result.data && result.data.success && result.data.body) {
      this.setState({
        cancelSuccess: true,
        renderCancelSuccess: true,
      });
      this.closeModal();
      if (this.state.pbCashSelected) {
        // this.setState({
        //   showModal: false,
        //   modalTitle: '',
        //   modalBody: '',
        //   buttonText1: '',
        //   modalChild: null,
        //   onButtonClick1: null,
        //   showButton2: false,
        //   buttonText2: null,
        //   modalIcon: null,
        //   couponSelected: false,
        // });
        //   Navigation.push(this.props.componentId, {
        //     component: {
        //         name: CANCEL_SUCCESS_SCREEN,
        //         passProps: {wallet:result.data.body.cancel_ticket.wallet,screenType:1},
        //         options: {
        //             topBar: {
        //                 title: {
        //                     text: 'Anular Pasaje',
        //                     fontFamily: Platform.OS === 'android' ? 'Carnas Regular' : 'Carnas-Regular',
        //                     alignment: 'center'
        //                 },
        //                 rightButtons:  {
        //                   id: 'rightHomeButton',
        //                   icon: require('../../assets/icons/home-icon.png')
        //                 },
        //                 leftButtons:[{}]
        //             },
        //         }
        //     }
        // });
      } else {
      }
      let selectedSeats = {};
      for (let k in this.ticketDetails.seat_Details.seat_details) {
        selectedSeats[k] = false;
      }
      this.setState({
        selectedSeats: selectedSeats,
      });
      let path = 'is_mobile_app=true';
      // this.props.getTicketDetails({callback:(result) => {},pnrNumber:this.ticketDetails.pnr_number,path:path})
    }
  };

  makePath = type => {
    const ticketDetails = this.ticketDetails;

    let newType = null;
    if (ticketDetails.pg_type === 46) {
      if (this.state.creditCardSelected) {
        newType = 18;
      } else if (this.state.bankSelected) {
        newType = 17;
      }
    }
    let path = 'pnr_number=' + ticketDetails.pnr_number;
    path += '&contact_info=' + ticketDetails.seat_Details.contact_details.email;
    path +=
      '&travel_date=' +
      DateService.changeDateFormat(ticketDetails.travel_date, 'dd/mm/yyyy', 'yyyy-mm-dd');
    path += '&seat_numbers=' + this.getSelectedSeats();
    path += newType !== null ? '&refund_type=' + newType : '&refund_type=' + type;
    path += '&is_kupos=true';

    if (this.isChangeTicketFinal) {
      path += '&is_change_ticket=true';
    }
    return path;
  };

  getSelectedSeats() {
    let selectedSeats = '';
    console.log(this.state.selectedSeats);
    for (let k in this.ticketDetails.seat_Details.seat_details) {
      if (
        this.state.selectedSeats[k] &&
        this.ticketDetails.seat_Details.seat_details[k].cancel_status === 0
      ) {
        selectedSeats += k + ',';
      }
    }
    return selectedSeats;
  }

  onSeatChecked = seatNo => {
    const checkCopy = { ...this.state.selectedSeats };

    let isPetSeat = false;

    if (this.props.common.ticketDetails.pet_seat_info) {
      for (let pair of this.props.common.ticketDetails.pet_seat_info) {
        for (let seat of pair) {
          if (seat == seatNo) {
            isPetSeat = true;
          }
        }
        if (isPetSeat) {
          if (checkCopy[pair[0]]) {
            checkCopy[pair[0]] = false;
            checkCopy[pair[1]] = false;
          } else {
            checkCopy[pair[0]] = true;
            checkCopy[pair[1]] = true;
          }
          break;
        }
      }
    }

    if (!isPetSeat) {
      if (checkCopy[seatNo]) checkCopy[seatNo] = false;
      else checkCopy[seatNo] = true;
    }

    let allSelected = true;
    for (let key in checkCopy) {
      if (!checkCopy[key]) {
        allSelected = false;
        break;
      }
    }
    this.setState({ selectedSeats: checkCopy, allSelected: allSelected });
  };

  selectAll = () => {
    const checkCopy = { ...this.state.selectedSeats };
    for (let key in checkCopy) {
      checkCopy[key] = !this.state.allSelected;
    }
    this.setState({ selectedSeats: checkCopy, allSelected: !this.state.allSelected });
  };

  showLoginModal = () => { };

  renderOtpView = () => {
    return (
      <div className="login-signup-inputs row light-placeholder">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginBottom: 20,
          }}
        ></div>

        <div className="login-signup-input  col-md-12 no-pad font11 mobile-signup-input no-border">
          <div className="flex-row otp-inps">
            <input
              value={this.state.otp1}
              ref="otp1"
              autoCorrect={false}
              type="password"
              onKeyUp={el => {
                let key = el.keyCode || el.charCode;
                if (key == 39) this.refs.otp2.focus();
              }}
              onChange={el => {
                this.setState({ otp1: CommonService.phoneNumberFormat(el.target.value, 1) });
                if (el.target.value) this.refs.otp2.focus();
                else this.refs.otp1.focus();
              }}
              autocomplete="new-password"
            />
            <input
              value={this.state.otp2}
              ref="otp2"
              autoCorrect={false}
              type="password"
              onKeyUp={el => {
                let key = el.keyCode || el.charCode;
                if (key == 8 || key == 46) this.refs.otp1.focus();
                if (key == 37) this.refs.otp1.focus();
                if (key == 39) this.refs.otp3.focus();
              }}
              onChange={el => {
                this.setState({ otp2: CommonService.phoneNumberFormat(el.target.value, 1) });
                if (el.target.value) this.refs.otp3.focus();
                // else this.refs.otp1.focus();
              }}
              autocomplete="new-password"
            />
            <input
              value={this.state.otp3}
              ref="otp3"
              autoCorrect={false}
              type="password"
              onKeyUp={el => {
                let key = el.keyCode || el.charCode;
                if (key == 8 || key == 46) this.refs.otp2.focus();
                if (key == 37) this.refs.otp2.focus();
                if (key == 39) this.refs.otp4.focus();
              }}
              onChange={el => {
                this.setState({ otp3: CommonService.phoneNumberFormat(el.target.value, 1) });
                if (el.target.value) this.refs.otp4.focus();
                // else this.refs.otp2.focus();
              }}
              autocomplete="new-password"
            />
            <input
              value={this.state.otp4}
              ref="otp4"
              autoCorrect={false}
              type="password"
              onKeyUp={el => {
                let key = el.keyCode || el.charCode;
                if (key == 8 || key == 46) this.refs.otp3.focus();
                if (key == 37) this.refs.otp5.focus();
              }}
              onChange={el => {
                this.setState({ otp4: CommonService.phoneNumberFormat(el.target.value, 1) });
                // this.refs.otp4.focus();
                if (el.target.value) this.refs.otp5.focus();
                // else this.refs.otp3.focus();
              }}
              autocomplete="new-password"
            />
            <input
              value={this.state.otp5}
              ref="otp5"
              autoCorrect={false}
              type="password"
              onKeyUp={el => {
                let key = el.keyCode || el.charCode;
                if (key == 8 || key == 46) this.refs.otp4.focus();
                if (key == 37) this.refs.otp6.focus();
              }}
              onChange={el => {
                this.setState({ otp5: CommonService.phoneNumberFormat(el.target.value, 1) });
                // this.refs.otp4.focus();
                if (el.target.value) this.refs.otp6.focus();
                // else this.refs.otp3.focus();
              }}
              autocomplete="new-password"
            />
            <input
              value={this.state.otp6}
              ref="otp6"
              autoCorrect={false}
              type="password"
              onKeyUp={el => {
                let key = el.keyCode || el.charCode;
                if (key == 8 || key == 46) this.refs.otp5.focus();
                if (key == 37) this.refs.otp6.focus();
              }}
              onChange={el => {
                this.setState({
                  otp6: CommonService.phoneNumberFormat(el.target.value, 1),
                  otpValidationError: false,
                });
                // this.refs.otp4.focus();
                if (el.target.value) this.refs.otp6.focus();
                // else this.refs.otp3.focus();
              }}
              autocomplete="new-password"
            />
          </div>
        </div>
        <div className="errorMessageInput font8 margin-auto">
          {this.state.otpValidationError ? 'required' : null}
        </div>
      </div>
    );
  };

  renderCancelSuccesFailureScreen = () => {
    if (this.state.cancelSuccess) {
      return (
        <KuposSuccessFailure
          success={true}
          // subtitle={this.props.t('CANCEL_TICKET.CHANGE_TICKET_PROCESSED')}
          // infoText={this.props.t('CANCEL_TICKET.CHANGE_TICKET_SENT_EMAIL')}
          subtitle={
            this.state.is_change_ticket
              ? this.props.t('CANCEL_TICKET.CHANGE_TICKET_PROCESSED')
              : this.props.t('CANCEL_TICKET.CANCELLATION_TICKET_PROCESSED')
          }
          infoText={
            this.state.is_change_ticket
              ? this.props.t('CANCEL_TICKET.CHANGE_TICKET_SENT_EMAIL')
              : this.props.t('CANCEL_TICKET.CANCELLATION_TICKET_THANKS')
          }
          t={this.props.t}
          appType={'change_ticket'}
        />
      );
    } else {
      return (
        <KuposSuccessFailure
          success={false}
          subtitle={this.props.t('CANCEL_TICKET.CANCELLATION_NOT_PROCESSED')}
          infoText={this.props.t('CANCEL_TICKET.SOMETHING_WENT_WRONG')}
          t={this.props.t}
          appType={'change_ticket'}
        >
          <FailedCancellation t={this.props.t} />
        </KuposSuccessFailure>
      );
    }
  };

  render() {
    const { t } = this.props;

    console.log('Props in cancellation details block is--------', this.props);
    console.log('State in cancellation details block is--------', this.state);
    console.log(this.isChangeTicketFinal);
    let cancel_offline = sessionStorage.getItem('offlineCancel') == 'true' ? true : false;

    return (
      <div className="cancellation-default-page">
        {!this.state.renderCancelSuccess ? (
          <div className="content-container cancellation-main">
            {this.isChangeTicketFinal ? (
              <div className="cancel-screen-title font20">
                {t('CANCEL_TICKET.CHANGE_TICKET.NORMAL')}{' '}
                <span className="bold-text"> {t('CANCEL_TICKET.CHANGE_TICKET.BOLD')}</span>
              </div>
            ) : (
              <div className="cancel-screen-title font20">
                {t('CANCEL_TICKET.TICKET_CANELLATION.NORMAL')}{' '}
                <span className="bold-text"> {t('CANCEL_TICKET.TICKET_CANELLATION.BOLD')}</span>
              </div>
            )}

            {this.props.common.ticketDetails ? (
              <PassengerDetailsBlock
                ticketDetails={this.props.common.ticketDetails}
                selectedSeats={this.state.selectedSeats}
                onSeatCheck={this.onSeatChecked}
                selectAll={this.selectAll}
                allSelected={this.state.allSelected}
                tncChecked={this.state.tncChecked}
                onTncChange={() => this.setState({ tncChecked: !this.state.tncChecked })}
                t={t}
                isChangeTicket={this.isChangeTicketFinal}
              />
            ) : null}

            {this.props.common.ticketDetails ? (
              <div className="kupos-card bank-deposit-subsection-card">
                <RefundDetailsBlock
                  ref={this.refundBlock}
                  onPgChange={state => this.setState({ ...state })}
                  paymentOptions={{
                    pbCashSelected: this.state.pbCashSelected,
                    bankSelected: this.state.bankSelected,
                    creditCardSelected: this.state.creditCardSelected,
                    paypalSelected: this.state.paypalSelected,
                    couponSelected: this.state.couponSelected,
                  }}
                  metaData={this.metaData}
                  ticketDetails={this.props.common.ticketDetails}
                  loginData={this.props.common.loginData}
                  showLoginModal={this.showLoginModal}
                  onResponse={this.onResponse}
                  cancelTicket={this.props.actions.cancelTicket}
                  t={t}
                  openCloseLoginModal={this.props.actions.openCloseLoginModal}
                  is_change_ticket={this.state.is_change_ticket}
                  offlineCancel={this.offlineCancel}
                />

                {this.isChangeTicketFinal ? (
                  <ChangeTicketPolicyBlock
                    paymentOptions={{
                      pbCashSelected: this.state.pbCashSelected,
                      // bankSelected: this.state.bankSelected,
                      // creditCardSelected: this.state.creditCardSelected,
                      // paypalSelected: this.state.paypalSelected,
                      // couponSelected: this.state.couponSelected,
                    }}
                    t={t}
                    type="bus"
                  />
                ) : (
                  <CancellationPolicyBlock
                    paymentOptions={{
                      pbCashSelected: this.state.pbCashSelected,
                      bankSelected: this.state.bankSelected,
                      creditCardSelected: this.state.creditCardSelected,
                      paypalSelected: this.state.paypalSelected,
                      couponSelected: this.state.couponSelected,
                    }}
                    t={t}
                    type="bus"
                  />
                )}

                <div className="bank-deposit-input-box font12 text-center margin-T20">
                  {this.state.showErrorsModal && (
                    <span className="error font9 " style={{ color: 'red' }}>
                      Debes aceptar los términos y condiciones para continuar
                    </span>
                  )}
                  <button
                    className="kupos-button"
                    style={{ margin: '10px auto' }}
                    onClick={cancel_offline ? this.showOtpInputs : this.onSubmit}
                  >
                    {this.state.loading ? (
                      <div className="loader-cricle"></div>
                    ) : this.isChangeTicketFinal ? (
                      <span> {t('HOME.CHANGE_YOUR_TICKET')}</span>
                    ) : (
                      <span> {t('CANCEL_TICKET.PROCEED_WITH_CANCELLATION')}</span>
                    )}
                  </button>
                  <div style={{ display: 'flex', justifyContent: 'center' }}></div>
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          this.renderCancelSuccesFailureScreen()
        )}
        <KuposModalWithButtons
          size="md"
          showModal={this.state.showModal}
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          type="alert"
          showButton1={true}
          buttonText1={this.state.buttonText1}
          onButtonClick1={this.state.onButtonClick1 ? this.state.onButtonClick1 : this.closeModal}
          showButton2={this.state.showButton2}
          buttonText2={this.state.buttonText2}
          onButtonClick2={this.state.onButtonClick2 ? this.state.onButtonClick2 : this.closeModal}
          icon={'/images/warning.png'}
          buttonTextStyle={{ fontSize: 15 }}
          // showCloseIcon={this.state.showCloseIcon}
          // closeIconPress={this.closeModal}
          onHide={this.closeModal}
          hideAllContent={this.props.cancellation.cancelTicketPending}
        >
          {this.props.cancellation.cancelTicketPending ? (
            <div className="cancel-loader">
              <span>{this.props.t('CANCEL_TICKET.LOADING')}</span>
            </div>
          ) : (
            <div className="cancel-confirm-modal-data font11 light-text">
              {/* <div className="flex-row">
                <span>{this.props.t('CANCEL_TICKET.TOTAL_AMOUNT')}</span>
                <span>CLP {CommonService.currency(this.state.totalAmount).split(',')[0]}</span>
              </div> */}
              {/* <div className="flex-row">
                <span>
                  {this.props.t('CANCEL_TICKET.CANCELLATION_FEE_SHORT')} (
                  <span className="bold-text">15%</span>)
                </span>
                <span>
                  CLP{' '}
                  {
                    CommonService.currency(
                      CommonService.percentage(this.state.totalAmount, 15),
                    ).split(',')[0]
                  }
                </span>
              </div> */}
              {/* {!this.state.pbCashSelected ? (
                <div className="flex-row">
                  <span>Cargo administrativo</span>
                  <span>CLP $600</span>
                </div>
              ) : null} */}
              {/* <hr /> */}
              {/* <div className="flex-row bold-text">
                <span>{this.props.t('CANCEL_TICKET.REFUND_TOTAL_AMOUNT')}</span>
                {!this.state.pbCashSelected ? (
                  <span>
                    CLP{' '}
                    {
                      CommonService.currency(
                        this.state.totalAmount -
                          CommonService.percentage(this.state.totalAmount, 15) -
                          600,
                      ).split(',')[0]
                    }
                  </span>
                ) : (
                  <span>
                    CLP{' '}
                    {
                      CommonService.currency(
                        this.state.totalAmount -
                          CommonService.percentage(this.state.totalAmount, 15),
                      ).split(',')[0]
                    }
                  </span>
                )}
              </div> */}

              <div className="text-center">{this.props.t('CANCEL_TICKET.CANCEL_MODAL_MSG1')}</div>

              <div className="text-center" style={{ marginTop: 10 }}>
                {this.props.t('CANCEL_TICKET.CANCEL_MODAL_MSG2')}
              </div>
            </div>
          )}
        </KuposModalWithButtons>

        <KuposModal
          showModal={this.state.showOtpModal}
          onHide={() => this.setState({ showOtpModal: false })}
          size="md"
          ariaLabel="login-modal"
          backdrop={false}
        >
          <div className="kupos-card log-in-card signup">
            <div className="login-signup-block">
              <div
                className="close-button pointer"
                style={{ top: -25, right: -10 }}
                onClick={() => this.setState({ showOtpModal: false, validateOtpPending: false })}
              >
                <SvgHome name="close" />
              </div>
              <div className="user-icon">
                <SvgCircularIcons name="forgot-password" />
              </div>
              <div className="bold-text center-text font16">
                {i18next.language == 'es' ? 'Autoriza tu pago' : 'Authorize your payment'}
              </div>
              <div style={{ marginTop: 10 }} className="center-text font11 light-text">
                {i18next.language == 'es'
                  ? 'Ingresa el código de 6 dígitos que enviamos a tu número de teléfono registrado.'
                  : 'Enter the 6-digit code we sent to your registered phone number.'}
              </div>

              {this.renderOtpView()}
              <div className="login-signup-button font12">
                <button
                  disabled={this.state.validateOtpPending}
                  className="kupos-button"
                  onClick={() => this.onSubmit()}
                >
                  {this.state.validateOtpPending ? (
                    <div className="loader-cricle"></div>
                  ) : (
                    <span>{this.props.t('RESULTS_PAGE.CONTINUE')}</span>
                  )}
                </button>
              </div>
              {/* <div className="register-link font10">
                <div>{this.props.t('PROFILE.NOT_RECEIVED_CODE')}</div>
                <a onClick={() => this.generateOtp()}>{this.props.t('PROFILE.CLICK_TO_RESEND')}</a>
              </div> */}
            </div>
          </div>
        </KuposModal>

        {/* <KuposModalWithButtons
          size="sm"
          showButton1={true}
          showModal={this.state.showErrorsModal}
          // buttonWidth="150px"
          onHide={this.onErrorModalHide}
        >
          {this.state.errors
            ? this.state.errors.map((val, key) => <div className="font11 center-text">{val}</div>)
            : null}
        </KuposModalWithButtons> */}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    cancellation: state.cancellation,
    common: state.common,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions, ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/cancellation/DefaultPage.js